import {
    FormControlLabel,
    Link,
    Radio,
    RadioGroup,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { GridCloseIcon } from "@mui/x-data-grid/components/icons";
import React from "react";
import SlidingPanel from "react-sliding-side-panel";
import DatePicker from "../../../../../../Supporting files/DatePicker/DatePicker";
import RKTextField from "../../../../../../Supporting files/RKTextField/RKTextField";
import SelectDropdown from "../../../../../../Supporting files/SelectDropdown/SelectDropdown";

interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

const AddMember: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const [toggle, setToggle] = React.useState(true);

  const [fullName, setFullName] = React.useState("");
  const [relationEmployee, setRelationEmployee] = React.useState("");
  const [selectFamily, setSelectFamily] = React.useState("");
  const [nomineeDob, setNomineeDob] = React.useState<Date | null>(new Date());

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };
  const handleClicktoogle = () => {
    setToggle(true);
  };
  const handleClicked = () => {
    setToggle(false);
  };

  const relationEmployee_data = [
    { key: "Brother", value: "Brother" },
    { key: "Sister", value: "Sister" },
  ];
  const selectFamily_data = [
    { key: "Brother", value: "Brother" },
    { key: "Sister", value: "Sister" },
  ];

  return (
    <SlidingPanel
      type={"right"}
      isOpen={open_status}
      size={75}
      backdropClicked={() => value_update(attrName, false)}
    >
      <div>
        <Grid container spacing={3} alignItems="center">
          <Grid xs={10}>
            <h4 className="mb-0 mt-3 text-left">Add Member</h4>
          </Grid>
          <Grid xs={2} textAlign="end" className="mt-2">
            <GridCloseIcon
              onClick={() => {
                value_update(attrName, false);
              }}
            />
          </Grid>

          <Grid xs={12} className="mb-4">
            <hr />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          alignItems="center"
          sx={{ paddingTop: "0" }}
        >
          <Grid xs={12} className="radio_button no-border">
            <>
              <RadioGroup row defaultValue="existing">
                <FormControlLabel
                  value="existing"
                  control={<Radio />}
                  label="Choose from existing family member"
                  onClick={handleClicktoogle}
                />
                <FormControlLabel
                  // checked
                  value="new"
                  control={<Radio />}
                  label="Add new member"
                  onClick={handleClicked}
                />
              </RadioGroup>
            </>
          </Grid>
          <Grid xs={12}>
            <div className="scrollable_area ">
              <Grid container spacing={3}>
                {toggle == true ? (
                  <>
                    <Grid xs={6}>
                      <SelectDropdown
                        class_name="inputField"
                        title="Select Family Member"
                        value={selectFamily}
                        attrName={setSelectFamily}
                        value_update={updateMasterState}
                        dropdown_data={selectFamily_data}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={6}>
                      <p className="health_ecard">
                        Relationship with Employee
                        <span>Brother</span>
                      </p>
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid xs={6}>
                      <RKTextField
                        class_name="inputField"
                        title="Full Name"
                        value={fullName}
                        attrName={setFullName}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={6}>
                      <SelectDropdown
                        class_name="inputField"
                        title="Relationship with employee"
                        value={relationEmployee}
                        attrName={setRelationEmployee}
                        value_update={updateMasterState}
                        dropdown_data={relationEmployee_data}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={6}>
                      <DatePicker
                        class_name="inputField"
                        title="Date of Birth"
                        value={nomineeDob}
                        attrName={setNomineeDob}
                        value_update={updateMasterState}
                        error_message="Please enter Date of Birth"
                        warn_status={false}
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            </div>
          </Grid>

          <Grid xs={12} className="footer_sec">
            <Link
              className="save_btn"
              onClick={() => value_update(attrName, false)}
            >
              Submit
            </Link>
          </Grid>
        </Grid>
      </div>
    </SlidingPanel>
  );
};

export default AddMember;
